import React from 'react'
import LayoutPage from '../Layout'
import { useNavigate } from 'react-router-dom';

function ContestWinner() {
    const navigate = useNavigate();
    const handleCloseButton = ()=>{
        navigate(-1);
    }
    
    const columns = [
        {
            name: "Rank",
            // selector: (row) => row.rank,
        },
        {
            name: "Name",
            // selector: (row) => row.name,
        },
        {
            name: "Contest Pts",
            // selector: (row) => row.contestPts,
        },
        {
            name: "Cumul Sports Pts",
            // selector: (row) => row.cumulPts,
        },
        {
            name: "All Sports Pts",
            //selector: (row) => row.allSportsPts,
        }
    ]
  return (
    <>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className=" shadow-primary border-radius-lg pt-0 pb-3"
                >
                  <h6 className="text-white text-capitalize ps-3 custom-card-heading">
                    <div className="d-flex justify-content-between align-item-center px-4">
                      {/* {row.sportName} Head-to-Head{" "} */} Contest Winners
                      <i
                        className="fa fa-close fonts"
                        onClick={handleCloseButton}
                        style={{ cursor: "pointer" }}
                      ></i>
                    </div>
                  </h6>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <div className="input-group input-group-dynamic">
                    &nbsp; &nbsp;
                  </div>
                  {/* <h1>Sports Categories</h1> */}
                  {/* <div className="table-responsive p-0">
                    <DataTable
                      columns={columns}
                      data={categoryData}
                      progressPending={loading}
                      paginationServer
                      paginationTotalRows={row.total}
                      onChangeRowsPerPage={handlePerRowsChange}
                      onChangePage={handlePageChange}
                      sortServer
                      pagination
                      // onSort={handleSort}
                      customStyles={customStyle}
                    />
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default ContestWinner
